import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ServiceBase } from '../../../shared/service-base/ServiceBase';

@Injectable()
export class RmpvDetalhadoFiltroService extends ServiceBase {

  private baseUrlService: string;
  url: string;

  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return this.url;
  }

  private definirURLFiltroMarca() {
    this.url = `${this.baseUrlService}/dash_filtro_marcas`;
  }

  public getFiltroMarcas(): Promise<any> {
    this.definirURLFiltroMarca();
    return this.get([]);
  }

  private definirURLFiltroTipos() {
    this.url = `${this.baseUrlService}/tipo_os`;
  }

  public getFiltroTipos(): Promise<any> {
    this.definirURLFiltroTipos();
    return this.get([]);
  }

  private definirURLFiltroDealers() {
    this.url = `${this.baseUrlService}/filtro/dealer`;
  }

  public getFiltroDealers(): any {
    this.definirURLFiltroDealers();
    return this.get([]);
  }

}
